import { useStopLists, useStopListSettings } from "@/api/stop-list.api";
import { CampaignStopWindow } from "@/components/stop-lists/CampaignStopWindow";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useCallback } from "react";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/define/stop-lists",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (context.trialPeriod)
      throw redirect({
        replace: true,
        to: "..",
      });
  },
  loader: () => ({
    showCampaignSetupBottomBar: false,
  }),
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { useEditCampaign } = Route.useRouteContext();
  const { data: stopLists } = useStopLists();
  const stopListSetting = useStopListSettings();

  const { editCampaign, setEditCampaign } = useEditCampaign();

  const onSubmit = useCallback(
    (data: string[]) => {
      setEditCampaign((prev) => ({
        ...prev,
        stopLists:
          stopLists?.filter((sL) =>
            data.some((i) => i === sL.uniqueId.toString()),
          ) ?? [],
      }));

      navigate({
        to: "/campaigns/$id/define",
      });
    },
    [navigate, setEditCampaign, stopLists],
  );

  return (
    <CampaignStopWindow
      isCreating={true}
      currentStopLists={editCampaign.stopLists ?? []}
      onSubmit={onSubmit}
      settings={stopListSetting.data}
      stopLists={stopLists}
      backLinkOptions={{
        to: "/campaigns/$id/define",
      }}
    />
  );
}
